import { useRouter } from 'next/router'
import { useCallback } from 'react'

type ValueAndSetterTuple = [string | null, (newValue: string | null) => void]

export function useQueryParamState(key: string): ValueAndSetterTuple {
  const { query, push } = useRouter()

  const value = getString(query[key])

  const setter = useCallback(
    (newValue: string | null) => {
      const newQuery = { ...query, [key]: newValue }

      if (typeof newValue !== 'string') {
        delete newQuery[key]
      }

      void push({ query: newQuery })
    },
    [key, query, push]
  )

  return [value, setter]
}

function getString(value: unknown): string | null {
  return typeof value === 'string' ? value : null
}
